import { useState, useEffect } from 'react'
import { dataService } from '../services/dataService'
import { offlineDB } from '../services/offlineDB'
import { X, Save, Package } from 'lucide-react'
import './AlbaranDialog.css'

function ordenProducto(nombre) {
  const n = (nombre || '').toLowerCase()
  if (n.includes('pan grande'))                            return 1
  if (n.includes('pan pequeño') || n.includes('pan peq')) return 2
  if (n.includes('barra')    && !n.includes('media'))      return 3
  if (n.includes('fabiola')  && !n.includes('media'))      return 4
  if (n.includes('integral') && n.includes('grande'))      return 5
  if (n.includes('media')    && n.includes('barra'))       return 6
  if (n.includes('media')    && n.includes('fabiola'))     return 7
  if (n.includes('media')    && n.includes('integral'))    return 8
  if (n.includes('bollo'))                                 return 9
  if (n.includes('rosco') && !n.includes('rosquilla'))     return 10
  if (n.includes('hogaza'))                                return 11
  if (n.includes('cruasan') || n.includes('croissant'))    return 12
  if (n.includes('napolitana'))                            return 13
  if (n.includes('magdalena'))                             return 14
  if (n.includes('pan rallado'))                           return 15
  if (n.includes('saco'))                                  return 16
  if (n.includes('rosquilla'))                             return 17
  if (n.includes('pasta'))                                 return 18
  return 19
}

export default function ClienteDialog({ cliente, onClose, onGuardar }) {
  const [formData, setFormData] = useState({
    razon_social: '',
    alias: '',
    cif: '',
    direccion: '',
    poblacion: '',
    provincia: '',
    cp: '',
    telefono: '',
    email: '',
    ruta: '',
    descuento_porcentaje: 0,
    quiere_factura: true,
    recargo_equivalencia: false,
    activo: true,
    dias_trabajo: ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'],
    periodo_facturacion: 'mensual',
    pago_en_dia: false
  })
  const [loading, setLoading] = useState(false)
  const [mostrarPlantilla, setMostrarPlantilla] = useState(false)
  const [productos, setProductos] = useState([])
  const [plantilla, setPlantilla] = useState({})
  const [rutas, setRutas] = useState([])
  const [nuevaRuta, setNuevaRuta] = useState('')

  const diasSemana = [
    { id: 'lunes', nombre: 'Lunes' },
    { id: 'martes', nombre: 'Martes' },
    { id: 'miercoles', nombre: 'Miércoles' },
    { id: 'jueves', nombre: 'Jueves' },
    { id: 'viernes', nombre: 'Viernes' },
    { id: 'sabado', nombre: 'Sábado' },
    { id: 'domingo', nombre: 'Domingo' }
  ]

  useEffect(() => { cargarDatosIniciales() }, [cliente])

  async function cargarDatosIniciales() {
    await Promise.all([cargarProductos(), cargarRutas()])
    if (cliente) {
      setFormData({
        ...cliente,
        dias_trabajo: cliente.dias_trabajo || ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'],
        pago_en_dia: cliente.pago_en_dia || false
      })
      await cargarPlantillaCliente(cliente.id)
    }
  }

  async function cargarProductos() {
    try {
      const productosRes = await dataService.getProducts()
      const prods = (productosRes.data || []).sort((a, b) => {
        const d = ordenProducto(a.nombre) - ordenProducto(b.nombre)
        return d !== 0 ? d : a.nombre.localeCompare(b.nombre)
      })
      setProductos(prods)
    } catch (error) { console.error('Error cargando productos:', error) }
  }

  async function cargarRutas() {
    try {
      const clientes = await offlineDB.getCachedClients()
      const rutasUnicas = [...new Set(clientes.map(c => c.ruta).filter(Boolean))].sort()
      setRutas(rutasUnicas)
    } catch (error) { console.error('Error cargando rutas:', error) }
  }

  async function cargarPlantillaCliente(clienteId) {
    try {
      const { data } = await dataService.getClientTemplates(clienteId)
      const plantillaMap = {}
      data?.forEach(item => {
        plantillaMap[item.product_id] = {
          qty_laboral: item.qty_laboral || 0,
          qty_sabado: item.qty_sabado || 0,
          qty_domingo: item.qty_domingo || 0
        }
      })
      setPlantilla(plantillaMap)
    } catch (error) { console.error('Error cargando plantilla:', error) }
  }

  function actualizar(campo, valor) {
    setFormData(prev => ({ ...prev, [campo]: valor }))
  }

  function toggleDia(dia) {
    setFormData(prev => {
      const dias = prev.dias_trabajo || []
      if (dias.includes(dia)) return { ...prev, dias_trabajo: dias.filter(d => d !== dia) }
      else return { ...prev, dias_trabajo: [...dias, dia] }
    })
  }

  function actualizarPlantilla(productId, campo, valor) {
    setPlantilla(prev => ({
      ...prev,
      [productId]: {
        ...(prev[productId] || { qty_laboral: 0, qty_sabado: 0, qty_domingo: 0 }),
        [campo]: Number(valor) || 0
      }
    }))
  }

  function handleRutaChange(valor) {
    if (valor === '__nueva__') { setNuevaRuta(''); actualizar('ruta', '') }
    else { actualizar('ruta', valor); setNuevaRuta('') }
  }

  async function guardar() {
    const rutaFinal = nuevaRuta.trim() || formData.ruta
    if (!formData.alias?.trim()) { alert('El alias es obligatorio'); return }
    if (!formData.razon_social?.trim()) { alert('La razón social es obligatoria'); return }
    if (!formData.cif?.trim()) { alert('El CIF es obligatorio'); return }
    if (!rutaFinal?.trim()) { alert('La ruta es obligatoria'); return }

    setLoading(true)
    try {
      const isNew = !cliente
      const clienteData = {
        ...formData,
        ruta: rutaFinal,
        descuento_porcentaje: Number(formData.descuento_porcentaje) || 0,
        pago_en_dia: Boolean(formData.pago_en_dia)
      }
      if (isNew && !navigator.onLine) clienteData.id = `temp_${Date.now()}_${Math.random()}`

      const result = await dataService.saveClient(clienteData, isNew)
      if (result.success) {
        const clienteId = result.data?.id || cliente?.id
        if (clienteId) await guardarPlantilla(clienteId)
        const mensaje = result.mode === 'offline'
          ? 'Cliente guardado OFFLINE. Se sincronizará cuando haya conexión.'
          : 'Cliente guardado correctamente.'
        alert(mensaje)
        onGuardar()
      }
    } catch (error) {
      console.error('❌ Error guardando cliente:', error)
      alert('Error al guardar: ' + error.message)
    } finally { setLoading(false) }
  }

  async function guardarPlantilla(clienteId) {
    try {
      if (clienteId.toString().startsWith('temp_')) return
      const registrosPlantilla = []
      Object.keys(plantilla).forEach(productId => {
        const p = plantilla[productId]
        if (p.qty_laboral > 0 || p.qty_sabado > 0 || p.qty_domingo > 0) {
          registrosPlantilla.push({
            client_id: clienteId, product_id: productId,
            qty_laboral: p.qty_laboral || 0, qty_sabado: p.qty_sabado || 0,
            qty_domingo: p.qty_domingo || 0, activo: true
          })
        }
      })
      await dataService.saveClientTemplates(clienteId, registrosPlantilla)
    } catch (error) { console.error('⚠️ Error guardando plantilla:', error) }
  }

  const inputStyle = { width: '100%', padding: '0.625rem', background: '#0e1116', border: '1px solid var(--line)', borderRadius: '6px', color: 'var(--fg)' }
  const labelStyle = { display: 'block', fontSize: '0.875rem', color: 'var(--muted)', marginBottom: '0.375rem' }

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '900px', maxHeight: '90vh' }}>
        <div className="dialog-header">
          <h2>{cliente ? 'Editar Cliente' : 'Nuevo Cliente'}</h2>
          <button className="btn-close" onClick={onClose}><X size={20} /></button>
        </div>

        <div className="dialog-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', borderBottom: '1px solid var(--line)' }}>
            <button onClick={() => setMostrarPlantilla(false)} style={{ padding: '0.75rem 1.5rem', background: !mostrarPlantilla ? 'var(--accent)' : 'transparent', color: !mostrarPlantilla ? '#000' : 'var(--fg)', border: 'none', borderBottom: !mostrarPlantilla ? '2px solid var(--accent)' : '2px solid transparent', cursor: 'pointer', fontWeight: 500 }}>
              Datos del cliente
            </button>
            <button onClick={() => setMostrarPlantilla(true)} style={{ padding: '0.75rem 1.5rem', background: mostrarPlantilla ? 'var(--accent)' : 'transparent', color: mostrarPlantilla ? '#000' : 'var(--fg)', border: 'none', borderBottom: mostrarPlantilla ? '2px solid var(--accent)' : '2px solid transparent', cursor: 'pointer', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Package size={16} /> Plantilla de reparto
            </button>
          </div>

          {!mostrarPlantilla ? (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div><label style={labelStyle}>Razón Social *</label><input type="text" value={formData.razon_social} onChange={(e) => actualizar('razon_social', e.target.value)} style={inputStyle} /></div>
              <div><label style={labelStyle}>Alias *</label><input type="text" value={formData.alias} onChange={(e) => actualizar('alias', e.target.value)} style={inputStyle} /></div>
              <div><label style={labelStyle}>CIF *</label><input type="text" value={formData.cif} onChange={(e) => actualizar('cif', e.target.value)} style={inputStyle} /></div>
              <div><label style={labelStyle}>Teléfono</label><input type="text" value={formData.telefono} onChange={(e) => actualizar('telefono', e.target.value)} style={inputStyle} /></div>
              <div style={{ gridColumn: '1 / -1' }}><label style={labelStyle}>Dirección</label><input type="text" value={formData.direccion} onChange={(e) => actualizar('direccion', e.target.value)} style={inputStyle} /></div>
              <div><label style={labelStyle}>Población</label><input type="text" value={formData.poblacion} onChange={(e) => actualizar('poblacion', e.target.value)} style={inputStyle} /></div>
              <div><label style={labelStyle}>Provincia</label><input type="text" value={formData.provincia} onChange={(e) => actualizar('provincia', e.target.value)} style={inputStyle} /></div>
              <div><label style={labelStyle}>Código Postal</label><input type="text" value={formData.cp} onChange={(e) => actualizar('cp', e.target.value)} style={inputStyle} /></div>
              <div><label style={labelStyle}>Email</label><input type="email" value={formData.email} onChange={(e) => actualizar('email', e.target.value)} style={inputStyle} /></div>

              <div>
                <label style={labelStyle}>Ruta *</label>
                <select value={formData.ruta || '__nueva__'} onChange={(e) => handleRutaChange(e.target.value)} style={inputStyle}>
                  <option value="">Seleccionar ruta...</option>
                  {rutas.map(ruta => <option key={ruta} value={ruta}>{ruta}</option>)}
                  <option value="__nueva__">+ Nueva ruta...</option>
                </select>
                {(!formData.ruta || formData.ruta === '__nueva__') && (
                  <input type="text" placeholder="Nombre de la nueva ruta" value={nuevaRuta}
                    onChange={(e) => { setNuevaRuta(e.target.value); actualizar('ruta', '') }}
                    style={{ ...inputStyle, marginTop: '0.5rem' }} />
                )}
              </div>

              <div><label style={labelStyle}>Descuento (%)</label>
                <input type="number" min="0" max="100" step="1" value={formData.descuento_porcentaje}
                  onChange={(e) => actualizar('descuento_porcentaje', Number(e.target.value))} style={inputStyle} />
              </div>

              <div>
                <label style={labelStyle}>Periodo de facturación</label>
                <select value={formData.periodo_facturacion} onChange={(e) => actualizar('periodo_facturacion', e.target.value)} style={inputStyle}>
                  <option value="semanal">Semanal</option>
                  <option value="mensual">Mensual</option>
                  <option value="a_demanda">A demanda</option>
                </select>
              </div>

              {/* Espaciador para mantener el grid */}
              <div />

              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ ...labelStyle, marginBottom: '0.75rem' }}>Días de trabajo *</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  {diasSemana.map(dia => (
                    <label key={dia.id} style={{
                      display: 'flex', alignItems: 'center', gap: '0.5rem',
                      padding: '0.5rem 0.875rem',
                      background: formData.dias_trabajo.includes(dia.id) ? 'var(--accent)' : 'var(--bg)',
                      color: formData.dias_trabajo.includes(dia.id) ? '#000' : 'var(--fg)',
                      border: '1px solid var(--line)', borderRadius: '6px', cursor: 'pointer',
                      transition: 'all 0.2s',
                      fontWeight: formData.dias_trabajo.includes(dia.id) ? '500' : 'normal'
                    }}>
                      <input type="checkbox" checked={formData.dias_trabajo.includes(dia.id)}
                        onChange={() => toggleDia(dia.id)} style={{ display: 'none' }} />
                      {dia.nombre}
                    </label>
                  ))}
                </div>
              </div>

              {/* Checkboxes en grid 2x2 */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input type="checkbox" id="quiere_factura" checked={formData.quiere_factura}
                  onChange={(e) => actualizar('quiere_factura', e.target.checked)} />
                <label htmlFor="quiere_factura" style={{ fontSize: '0.9375rem', cursor: 'pointer' }}>Quiere factura</label>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input type="checkbox" id="recargo_equivalencia" checked={formData.recargo_equivalencia}
                  onChange={(e) => actualizar('recargo_equivalencia', e.target.checked)} />
                <label htmlFor="recargo_equivalencia" style={{ fontSize: '0.9375rem', cursor: 'pointer' }}>Recargo de Equivalencia</label>
              </div>

              {/* ← NUEVO */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input type="checkbox" id="pago_en_dia" checked={formData.pago_en_dia}
                  onChange={(e) => actualizar('pago_en_dia', e.target.checked)} />
                <label htmlFor="pago_en_dia" style={{ fontSize: '0.9375rem', cursor: 'pointer' }}>
                  💵 Paga en el día
                </label>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input type="checkbox" id="activo" checked={formData.activo}
                  onChange={(e) => actualizar('activo', e.target.checked)} />
                <label htmlFor="activo" style={{ fontSize: '0.9375rem', cursor: 'pointer' }}>Cliente activo</label>
              </div>

            </div>
          ) : (
            <div>
              <div style={{ marginBottom: '1rem', padding: '0.75rem', background: 'rgba(45, 212, 191, 0.1)', borderRadius: '6px', fontSize: '0.875rem' }}>
                📦 Define las cantidades habituales que este cliente suele llevar cada día
              </div>
              <div className="tabla-wrapper">
                <table className="tabla-lineas">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th style={{ width: '100px', textAlign: 'center' }}>L-V</th>
                      <th style={{ width: '100px', textAlign: 'center' }}>Sábado</th>
                      <th style={{ width: '100px', textAlign: 'center' }}>Domingo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productos.map(producto => {
                      const cant = plantilla[producto.id] || { qty_laboral: 0, qty_sabado: 0, qty_domingo: 0 }
                      return (
                        <tr key={producto.id}>
                          <td>{producto.nombre}</td>
                          <td><input type="number" min="0" step="1" value={cant.qty_laboral} onChange={(e) => actualizarPlantilla(producto.id, 'qty_laboral', e.target.value)} className="input-cantidad" /></td>
                          <td><input type="number" min="0" step="1" value={cant.qty_sabado} onChange={(e) => actualizarPlantilla(producto.id, 'qty_sabado', e.target.value)} className="input-cantidad" /></td>
                          <td><input type="number" min="0" step="1" value={cant.qty_domingo} onChange={(e) => actualizarPlantilla(producto.id, 'qty_domingo', e.target.value)} className="input-cantidad" /></td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        <div className="dialog-footer">
          <button onClick={onClose} className="btn-secondary">Cancelar</button>
          <button onClick={guardar} disabled={loading} className="btn-primary">
            <Save size={18} /> {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  )
}
